// extracted by mini-css-extract-plugin
export default {"modal-overlay":"modal-overlay_modal-overlay__ml4DS"};